<template>
  <div>
    <v-main>
      <div>
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="12">
                  <v-list three-line subheader>
                    <!-- <v-card-title class="lighten-5">
                      ข้อมูลส่วนตัว
                      <v-icon color="#871B12"
                        >mdi-account-circle-outline
                      </v-icon>
                    </v-card-title> -->
                    <v-app-bar fixed app no-gutters color="indigo" dark>
                      <v-toolbar-title>ข้อมูลส่วนตัว</v-toolbar-title>

                      <v-col class="text-right">
                        <v-btn icon @click="closePage()">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-app-bar>
                    <!-- <v-divider color="#871B12"></v-divider> -->
                    <v-col cols="12" class="text-center">
                        <v-avatar size="150px" class="grey lighten-3 mb-3">
                          <img :src="dataImg" />
                        </v-avatar>
                        <br />
                        <v-row justify="center" align="center">
                          <v-list-item-title>รหัสพนักงาน</v-list-item-title>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="12" sm="3">
                            <v-text-field
                              class="centered-input text--darken-3 mt-3"
                              color="#871B12"
                              single-line
                              v-model="formUpdate.empCode"
                              disabled
                              :error="false"
                              required
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                    </v-col>
                  </v-list>
                  <v-list three-line subheader>
                    <!--{{formUpdate}}-->
                    <v-card-text>
                      <v-container class="py-1">
                        <v-form
                          ref="form_add"
                          v-model="valid_add"
                          lazy-validation
                        >
                          <v-row>
                            <div>
                              <v-card elevation="20">
                                <v-card-title class="text-h5">
                                  <v-col cols="12">
                                    <v-text-field
                                      label="ข้อมูลส่วนตัว"
                                      disabled
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                      v-model="formUpdate.empTitle_NameTH"
                                      label="คำนำหน้า *"
                                      disabled
                                      dense
                                      outlined
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                      label="ชื่อ ภาษาไทย *"
                                      v-model="formUpdate.empFirst_NameTH"
                                      disabled
                                      dense
                                      outlined
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                      v-model="formUpdate.empLast_NameTH"
                                      label="นามสกุล ภาษาไทย *"
                                      disabled
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empTitle_NameEN"
                                      label="คำนำหน้า *"
                                      disabled
                                      dense
                                      outlined
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empFirst_NameEN"
                                      label="ชื่อ ภาษาอังกฤษ *"
                                      disabled
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empLast_NameEN"
                                      label="นามสกุล ภาษาอังกฤษ *"
                                      disabled
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empNickname"
                                      label="ชื่อเล่น *"
                                      disabled
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empGender"
                                      label="เพศ *"
                                      disabled
                                      dense
                                      outlined
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empBirthday"
                                      :return-value.sync="date"
                                      :value="computedDateBB"
                                      label="วัน-เดือน-ปี เกิด *"
                                      disabled
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.AGE"
                                      label="อายุ"
                                      disabled
                                      dense
                                      outlined
                                    />
                                  </v-col>
                                </v-card-title>
                              </v-card>
                              <br />
                              <br />
                            </div>

                            <div>
                              <v-card elevation="20">
                                <v-card-title class="text-h5">
                                  <v-col cols="12">
                                    <template>
                                      <v-text-field
                                        label="ข้อมูลการติดต่อ"
                                        color="success"
                                        disabled
                                      ></v-text-field>
                                    </template>
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empTel"
                                      label="เบอร์โทรศัพท์ *"
                                      maxlength="10"
                                      counter="10"
                                      :rules="numberRules"
                                      required
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empEmergencyName"
                                      label="ชื่อบุคคลฉุกเฉิน"
                                      required
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                   <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empEmergencyCall"
                                      label="เบอร์โทรฉุกเฉิน"
                                      maxlength="10"
                                      counter="10"
                                      required
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empEmail"
                                      label="อีเมล์ *"
                                      counter="50"
                                      maxlength="50"
                                      value="example"
                                      required
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empFacebook"
                                      label="Facebook"
                                      counter="30"
                                      maxlength="30"
                                      required
                                      dense
                                      outlined
                                    />
                                  </v-col>

                                  <v-col cols="12" sm="4">
                                    <v-text-field
                                      v-model="formUpdate.empLineID"
                                      label="LINE ID"
                                      counter="20"
                                      maxlength="20"
                                      required
                                      dense
                                      outlined
                                    />
                                  </v-col>
                                </v-card-title>
                              </v-card>
                              <br />
                              <br />
                            </div>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>
                  </v-list>
                <br />
                <v-row no-gutters>
                  <v-footer fixed height="60px" color="#262A34">
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="success"
                        @click="editData(formUpdate)"
                        :disabled="!valid_add"
                      >
                        บันทึกข้อมูล
                        <v-icon right>mdi-checkbox-marked-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-footer>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
export default {
  components: {
    moment
  },
  name: 'Info',
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  computed: {
    computedDateBB () {
      if (this.formUpdate.empBirthday) {
        let dateTh = moment(this.formUpdate.empBirthday)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH = dateTh
        return this.showDateTH
      }
    }
  },
  data () {
    return {
      rollHR: false,
      showDateTH: '',
      value: 1,
      PK: '',
      path: '/employee/', // Path Model
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      valid_add: true,
      formUpdate: [],
      dataImg: '',
      nameRules: [(v) => !!v || 'Input is required'],
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) => (v && v.length === 10) || 'Max 10 characters'
      ],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      empId: '',
      files: null,
      dataEmp: [],
      profile: []
    }
  },
  async mounted () {
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.profile.empImageUrl = this.profile.empImageUrl
    await this.getDataByEmpcode()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        default:
          break
      }
    },
    async getDataByEmpcode () {
      console.log('this.profile.empCode', this.profile.empCode)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee_get_update/getEmpCode?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            Object.assign(this.formUpdate, response.data[0])
            this.dataImg = this.DNS_IP + '/' + this.formUpdate.empImageUrl
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async editData (formUpdate) {
      console.log('formUpdate', formUpdate)
      // let id = this.formUpdate['empId']
      // let dt = this.formUpdate
      this.dataReady = false
      // this.dialogAdd = false
      // this.$swal({
      //   title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
      //   type: 'question',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#b3b1ab',
      //   confirmButtonText: 'ใช่',
      //   cancelButtonText: 'ไม่'
      // })
      //   .then(async (result) => {
      let ds = {
        empEmail: formUpdate.empEmail,
        empTel: formUpdate.empTel,
        empEmergencyCall: formUpdate.empEmergencyCall,
        empEmergencyName: formUpdate.empEmergencyName,
        empFacebook: formUpdate.empFacebook,
        empLineID: formUpdate.empLineID,
        LAST_USER: JSON.parse(localStorage.getItem('liff_info')).userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_update/edit/" + formUpdate.empId,
          ds,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.$swal('บันทึกข้อมูลเรียบร้อย', 'โปรด ตรวจสอบข้อมูลหน้าถัดไป', 'success')
          this.$router.push(
            '/Liff/EmpFamily'
          )
          // console.log(response)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          // console.log(error)
        })
        // })
        // .catch((error) => {
        //   this.dataReady = true
        //   console.log('error function editDataSubmit 3  : ', error)
        // })
    },
    closePage () {
      this.$router.push('/Liff/HomeEmployee')
    }
  }
}
</script>
<style scope>
.scroll {
  overflow-y: scroll;
}
.lighten-5 {
  font-family: Kanit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;

  color: #871b12;
}
.centered-input input {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/EmpInfomation.vue